import ReferencedInputAndSubmit from "../../../../../layout/Form/Fields/ReferencedInputAndSubmit";
import TagLikeHandler from "@serie3/freelancesplaceapi/Form/shared/TagLikeHandler";
import Tag from "../../../../../layout/Buttons/Tag";
import { useRef } from "react";
import { Col, Row } from "react-bootstrap";

const ActionTags = ({ formik, allTags, setAllTags }) => {
  const tagRef = useRef(null);

  const addElement = (refName, valueName) => {
    TagLikeHandler.addElement(formik, refName, valueName, true);
    const tmpArray = [...formik.values.tags];
    setAllTags(tmpArray);
  };

  const deleteElement = (index) => {
    const newTags = allTags.filter((_, i) => i !== index);
    setAllTags(newTags);
    formik.setFieldValue("tags", newTags);
  };

  return (
    <>
      <Row>
        <ReferencedInputAndSubmit
          namedReference={tagRef}
          onClick={() => {
            addElement(tagRef, "tags");
          }}
        />
      </Row>
      <Row style={{ marginTop: "10px" }}>
        <Col>
          {allTags.length > 0
            ? allTags.map((tag, index) => {
                return (
                  <Tag
                    key={index}
                    item={tag}
                    content={tag.name}
                    deleteFunction={() => deleteElement(index)}
                  />
                );
              })
            : null}
        </Col>
      </Row>
    </>
  );
};

export default ActionTags;
